//Getters
export const GET_OPERACAO = 'GET_OPERACAO'

// Actions
export const SET_OPERACAO_FROM_API = 'SET_OPERACAO_FROM_API'
export const SET_OPERACAO = 'SET_OPERACAO'